import React, { useMemo } from "react";
import classnames from "classnames";
import TableCell from "~/core/components/tables/data-table/components/table-cell";

interface IProps {
    data: any[];
    headerRow: boolean;
    selectedSampleAttributes: any[];
    showMappedAttributes: boolean;
}

function printRow(headerRow: boolean, valueList: any[]) {
    return (
        valueList &&
        valueList.map((attr, index) => {
            const classNames = classnames({
                "template-manager-grid-cell": true,
                "is-header-row": headerRow && index === 0,
            });
            return (
                <TableCell
                    key={`template-grid-${attr}-${index}`}
                    className={classNames}
                    title={attr}
                >
                    {attr}
                </TableCell>
            );
        })
    );
}

export function TemplateManagerRows(props: IProps) {
    const { selectedSampleAttributes, showMappedAttributes, data, headerRow } = props;

    const selectedSampleAttributeHash = useMemo(
        () =>
            new Set<string>(
                selectedSampleAttributes.map(({ columnNameInFile }) => columnNameInFile)
            ),
        [selectedSampleAttributes]
    );

    const filteredData = useMemo(() => {
        if (showMappedAttributes) {
            return (
                data &&
                data.filter(({ valueList }) => selectedSampleAttributeHash.has(valueList[0]))
            );
        }
        return data;
    }, [selectedSampleAttributeHash, showMappedAttributes, data]);

    return (
        <div className="template-manager-rows">
            {data &&
                filteredData.map(({ valueList }, index) => (
                    <div className="grid-row" key={`template-grid-row-${index}`}>
                        {printRow(headerRow, valueList)}
                    </div>
                ))}
        </div>
    );
}
